export default "__VITE_ASSET__988e665b__"